var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GroupsModal',{ref:"status-permissions-modal",attrs:{"groups":_vm.groups,"value":_vm.value,"name":_vm.id,"loading":_vm.loading,"disabled":_vm.disabled,"clientName":_vm.clientName},on:{"input":_vm.setSelectedGroups,"cancel":_vm.onCancel,"onSubmit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }